/**
 * External Dependencies
 */
import 'jquery';
import Blazy from 'blazy';
import 'slick-carousel/slick/slick.min';
import List from 'list.js';

let bLazy = new Blazy();
const $body = $('body');

$(document).on('ready', () => {
  // Lazy Loading
  bLazy.load();

  // Loader
  $(window).on('load', () => {
    $body.addClass('loaded');
    bLazy.revalidate();
    popLoad();
  });

  // One by One Pop
  function popLoad() {
    let delay = 0,
        $listSizeItem = $('ul.list').find('li.project');
    setTimeout(function() {
      $($listSizeItem).each(function() {
        var $item = $(this);
        setTimeout(function() {
          $item.addClass('visible');
        }, delay+=150);
      });
    }, 150);
  }

  // Filtering
  if($('input.search').length > 0) {
    $('input.search').focus();
  }

  var options = {
    valueNames: [ 'title', 'categories' ],
  };

  const filterList = new List('filter-list', options);

  $('a.category').on('click', (e) => {
    e.preventDefault();
    let $this = $(e.currentTarget);
    $('a.category').removeClass('active');
    $this.addClass('active');

    $('ul.list > li').each(function() {
      $(this).removeClass('visible active');
    });

    if($this.hasClass('show-all')) {
      filterList.filter();
      return false;
    } else {
      var selection = $this.data('slug');
      filterList.filter(function(item) {
        var cats = item.values().categories.split(', ');
        for (var i=0, j=cats.length; i<j; i++) {
          if (cats[i] == selection) {
            return true;
          }
        }
      });
    }
  });

  filterList.on('updated', function() {
    popLoad();
  });

  // Project Toggle
  $('li.project').on('click', '.js-reveal-toggle', (e) => {
    e.preventDefault();
    let $this = $(e.currentTarget);
    let $project = $this.parents('li.project');
    let id = $this.attr('href');
    let projectVid = $project.find('video');
    let projectCarousel = $project.find('.slick');
    
    // Toggle
    if($project.hasClass('active')) {
      $project.removeClass('active');
    } else {
      // Close other windows
      $('ul.list').find('li.project.active').removeClass('active');

      // Open the project
      $project.addClass('active');
    }

    //  Scroll to it
    setTimeout(function() {
      if($project.hasClass('active')) {
        bLazy.revalidate();

        if(projectVid.length > 0) {
          $(projectVid).get(0).play();
        }
        if(projectCarousel.length > 0) {
          // Build the carousel
          projectCarousel.slick({
            lazyLoad: 'ondemand',
            fade: true,
            speed: 500,
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: true,
            prevArrow: $('.prev-arrow'),
            nextArrow: $('.next-arrow'),
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: false,
            adaptiveHeight: true,
          });
          // Start it
          projectCarousel.slick('slickPlay');
        }
      } else {
        if(projectVid.length > 0) {
          $(projectVid).get(0).pause();
        }
        if(projectCarousel.length > 0) {
          projectCarousel.slick('slickPause');
        }
      }
      $('html').animate({scrollTop: $(id).offset().top - 40}, 'slow');
    }, 500);
  });

  // Resize
  $(window).on('resize', () => {
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function(){
      bLazy.revalidate();
      if(slider.length > 0) {
        slider.slick('init');
      }
    }, 100);
  });

  if($body.hasClass('single')) {
    let $article = $('article.post');
    let articleVid = $article.find('video');
    let articleCarousel = $article.find('.slick');

    bLazy.revalidate();

    if(articleVid.length > 0) {
      $(articleVid).get(0).play();
    }

    if(articleCarousel.length > 0) {
      // Build the carousel
      articleCarousel.slick({
        lazyLoad: 'ondemand',
        fade: true,
        speed: 500,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: true,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: false,
        adaptiveHeight: true,
      });
    }
  }
});
